export const COMPANIES_GET_REQUESTED = 'COMPANIES_GET_REQUESTED';
export const COMPANIES_GET_SUCCEED = 'COMPANIES_GET_SUCCEED';
export const COMPANIES_GET_FAILED = 'COMPANIES_GET_FAILED';
